import React, { useContext } from "react";

// components
import QueryModule from "../../modules/query/Module";
import SchemaModule from "../../modules/schema/Module";
import WCSModule from "../../modules/wcs/Module";
import HomePage from "./HomePage";

import { StateContext } from "../../AppStateContext";

const Content = () => {
  const state = useContext(StateContext);

  if (
    state.currentModule === "Query" ||
    state.currentModule === "query" ||
    window.location.pathname.includes("/Query" || "/query")
  ) {
    return <QueryModule />;
  } else if (
    state.currentModule === "Schema" ||
    state.currentModule === "schema" ||
    window.location.pathname.includes("/Schema" || "/schema")
  ) {
    return <SchemaModule />;
  } else if (
    state.currentModule === "WCS" ||
    state.currentModule === "wcs" ||
    state.currentModule === "Wcs" ||
    window.location.pathname.includes("/WCS" || "/wcs" || "Wcs")
  ) {
    return <WCSModule />;
  } else if (
    state.currentModule === "HOME" ||
    state.currentModule === "home" ||
    state.currentModule === "Home" ||
    window.location.pathname.includes("/HOME" || "/Home" || "home")
  ) {
    return <HomePage />;
  } else {
    return null;
  }
};

export default Content;
